<div class="team-select">
  <!-- Icon to close dialog -->
  <img src="assets/icons/general/close.svg" class="team-select__close" routerLink="/dashboard" />
  <!-- TEAMS OVERVIEW MODE (Only displayed if not a member of a team yet)-->
  <ng-container *ngIf="mode === TeamSelectMode.TEAMS_OVERVIEW">
    <h2 class="team-select__heading">{{ 'TEAMSELECT.overview.heading' | translate }}</h2>
    <div
      class="team-select__box team-select__box--has-scrollbar"
      [ngClass]="{ 'team-select__box--no-entries': !teams || teams?.length === 0 }"
    >
      <ng-container *ngIf="teams?.length > 0">
        <p>
          <span class="team-select__team-name team-select__team-label"> {{ 'TEAMSELECT.name' | translate }} </span>
          <span class="team-select__team-members team-select__team-label">
            {{ 'TEAMSELECT.members' | translate }}
          </span>
        </p>

        <div class="team-select__team-scroll-container">
          <div *ngFor="let team of teams" class="team-select__team">
            <span class="team-select__team-name"> {{ team.name }} </span>
            <span
              class="team-select__team-members"
              [ngClass]="{
                'team-select__team-members--full':
                  !team.hasInvitation &&
                  challenge?.maximumTeamMembers &&
                  challenge?.maximumTeamMembers <= team?.userGroups?.invitations?.length + team?.userGroups?.members?.length
              }"
            >
              {{ team?.userGroups?.invitations?.length + team?.userGroups?.members?.length }}
              <span *ngIf="challenge?.maximumTeamMembers">/ {{ challenge?.maximumTeamMembers }}</span>
            </span>
            <div class="team-select__team-button-container">
              <app-button
                *ngIf="!team.hasInvitation"
                class="team-select__team-button"
                type="standard"
                [label]="'TEAMSELECT.overview.join' | translate"
                [disabled]="
                  challenge?.maximumTeamMembers &&
                  challenge?.maximumTeamMembers <= team?.userGroups?.invitations?.length + team?.userGroups?.members?.length
                "
                (onClick)="showConfirmJoinDialog(team._id)"
              ></app-button>

              <app-button
                *ngIf="team.hasInvitation"
                class="team-select__team-button"
                type="primary"
                [label]="'TEAMSELECT.overview.acceptInvitation' | translate"
                (click)="acceptInvitation(team._id)"
              >
              </app-button>

              <app-button
                *ngIf="team.hasInvitation"
                class="team-select__team-button"
                type="error"
                [label]="'TEAMSELECT.overview.denyInvitation' | translate"
                (click)="denyInvitation(team._id)"
              >
              </app-button>
            </div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!teams || teams?.length === 0">{{ 'TEAMSELECT.overview.noTeams' | translate }}</div>
    </div>

    <h3 class="team-select__create-heading">{{ 'TEAMSELECT.overview.createTeamHeading' | translate }}</h3>
    <h2 class="team-select__create-subheading">{{ 'TEAMSELECT.overview.chooseName' | translate }}</h2>

    <form [formGroup]="createTeamForm" action="">
      <div class="team-select__container">
        <input
          #teamName
          class="team-select__create-input"
          type="text"
          [formControlName]="'name'"
          [placeholder]="'TEAMSELECT.overview.namePlaceholder' | translate"
        />

        <app-button
          type="primary"
          [disabled]="!createTeamForm.valid"
          [label]="'TEAMSELECT.overview.createTeam' | translate"
          (onClick)="createTeam()"
        ></app-button>
      </div>

      <div class="team-select__team-hint">
        <img src="assets/icons/general/info-circle.svg" class="team-select__icon" />
        <p class="team-select__team-hint-text">{{ 'TEAMSELECT.hintName' | translate }}</p>
      </div>
    </form>
  </ng-container>

  <!-- CONFIRM JOIN MODE (Only displayed when needs to confirm that she wants to join the team )-->
  <ng-container *ngIf="mode === TeamSelectMode.CONFIRM_JOIN">
    <h2 class="team-select__heading">{{ 'TEAMSELECT.confirmJoin.heading' | translate }}</h2>

    <div class="team-select__box">
      <p class="team-select__confirm-subheading">{{ 'TEAMSELECT.confirmJoin.subheading' | translate }}</p>

      <div class="team-select__confirm-team">
        <span class="team-select__confirm-team-name team-select__confirm-team-label"> {{ 'TEAMSELECT.name' | translate }}</span>
        <span class="team-select__confirm-team-users team-select__confirm-team-label"> {{ 'TEAMSELECT.members' | translate }}</span>
        <span class="team-select__confirm-team-name">{{ teamDetails?.name }} </span>
        <span class="team-select__confirm-team-users"
          >{{ teamDetails?.userGroups?.invitations?.length + teamDetails?.userGroups?.members?.length }}
        </span>
      </div>

      <div class="team-select__confirm-hint team-select__confirm-hint--highlight">
        <img src="assets/icons/general/info-circle.svg" class="team-select__icon" />
        <p class="team-select__confirm-hint-text">{{ 'TEAMSELECT.hint' | translate }}</p>
      </div>

      <div class="team-select__container">
        <app-button type="secondary" [label]="'TEAMSELECT.confirmJoin.editChoice' | translate" (onClick)="cancelDialog()"></app-button>
        <app-button type="primary" [label]="'TEAMSELECT.confirmJoin.confirmChoice' | translate" (onClick)="applyForTeam()"></app-button>
      </div>
    </div>
  </ng-container>

  <!-- TEAM DETAILS MODE (Displayed if user is in team founding process) -->
  <ng-container *ngIf="mode === TeamSelectMode.TEAM_DETAILS">
    <h2 class="team-select__heading">{{ 'TEAMSELECT.teamDetails.heading' | translate }}</h2>

    <div class="team-select__box">
      <div *ngIf="challenge?.minimalTeamMembers" class="team-select__details-minimumMembers">
        <img src="assets/icons/general/info-circle.svg" class="team-select__icon" />
        <span class="team-select__details-minimumMembers-text"
          >{{ 'TEAMSELECT.teamDetails.hint' | translate: { minimumTeamMembers: challenge?.minimalTeamMembers } }}
        </span>
      </div>

      <div class="team-select__details-info">
        <span class="team-select__details-info-value team-select__details-info-label">{{ 'TEAMSELECT.name' | translate }}</span>
        <span class="team-select__details-info-value team-select__details-info-label">{{ 'TEAMSELECT.founder' | translate }}</span>
        <span class="team-select__details-info-value">{{ teamDetails?.name }} </span>
        <span class="team-select__details-info-value">{{ founder?.firstName }} {{ founder?.lastName }}</span>
      </div>

      <p class="team-select__details-info-label">
        {{ 'TEAMSELECT.members' | translate }}
        <span *ngIf="challenge?.maximumTeamMembers">
          ({{
            'TEAMSELECT.teamDetails.occupiedSpots'
              | translate
                : {
                    occupiedSlots:
                      teamDetails?.userGroups?.invitations?.length + teamDetails?.userGroups?.members?.length + invitedUsers.length,
                    maximumTeamMembers: challenge?.maximumTeamMembers
                  }
          }})
        </span>
      </p>

      <div class="team-select__details-user-container">
        <div class="team-select__details-user">
          <span class="team-select__details-user-name">
            {{ founder?.firstName }} {{ founder?.lastName }}
            <span class="team-select__details-user-role">({{ 'TEAMSELECT.founder' | translate }})</span>
          </span>
        </div>
        <div *ngFor="let user of invitedUsers" class="team-select__details-user">
          <span class="team-select__details-user-name"
            >{{ user.firstName || user.lastName ? user.firstName + ' ' + user.lastName : user.email }}
          </span>
          <app-button
            type="secondary"
            [label]="'TEAMSELECT.teamDetails.cancelInvitation' | translate"
            (onClick)="cancelInvitation(user.email)"
          ></app-button>
        </div>
      </div>

      <form [formGroup]="inviteUserForm" action="">
        <div class="team-select__details-add">
          <div class="team-select__details-add-container">
            <img src="assets/icons/general/add.svg" class="team-select__icon team-select__details-add-icon" />
            <input
              *ngIf="
                teamDetails?.userGroups?.invitations?.length + teamDetails?.userGroups?.members?.length < challenge?.maximumTeamMembers
              "
              #inviteUser
              class="team-select__create-input"
              type="email"
              [formControlName]="'email'"
              [placeholder]="'TEAMSELECT.teamDetails.enterEmail' | translate"
            />
            <input
              *ngIf="
                teamDetails?.userGroups?.invitations?.length + teamDetails?.userGroups?.members?.length >= challenge?.maximumTeamMembers
              "
              #inviteUser
              class="team-select__create-input"
              type="email"
              [value]="'TEAMSELECT.teamDetails.memberlimitReached' | translate"
              disabled
            />
          </div>
          <app-button
            type="primary"
            [label]="'TEAMSELECT.teamDetails.invite' | translate"
            [disabled]="
              inviteUserForm.invalid ||
              teamDetails?.userGroups?.invitations?.length + teamDetails?.userGroups?.members?.length >= challenge?.maximumTeamMembers
            "
            (onClick)="inviteUserToTeam()"
          ></app-button>
        </div>
      </form>

      <div class="team-select__container">
        <app-button type="secondary" [label]="'TEAMSELECT.teamDetails.back' | translate" (onClick)="cancelTeamCreation()"></app-button>
        <app-button type="primary" [label]="'TEAMSELECT.teamDetails.finishCreate' | translate" (click)="finishTeamCreation()"></app-button>
      </div>
    </div>
  </ng-container>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/team-select/team-select.component.html